import React from 'react';
import PropTypes from 'prop-types';

import { i18n as I18n } from '../../../utils/i18n';

// Components
import InstructionalFormActions from '../../instructionalForm/actions';

const ServiceDetailsContainer = ({
  children,
  handleSubmit,
  submissionErrors,
  isValid,
  handleGoBack,
  showBackBtn,
  handleCancel,
  showCancelButton,
  title,
  previousStep,
}) => {
  return (
    <form
      className="instructional-form__form"
      onSubmit={handleSubmit}
      data-testid="serviceDetailsForm"
      data-cy="serviceDetailsForm"
    >
      <h2 data-cy="registrationHeader">{title}</h2>

      {children}

      {submissionErrors && submissionErrors.length > 0 && (
        <div className="registration-submission-errors">
          <p>{I18n.t('registration.service_details.submission_failed')}</p>
          <ul>
            {submissionErrors.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        </div>
      )}

      <InstructionalFormActions
        isValid={isValid}
        showBackBtn={showBackBtn}
        submitBtnText={I18n.t(
          'registration.service_details.submit_for_approval'
        )}
        backBtnText={I18n.t('back_to_step', { step: previousStep })}
        handleBackBtnClick={handleGoBack}
        handleCancleBtnClick={handleCancel}
        showCancelBtn={showCancelButton}
      />
    </form>
  );
};

ServiceDetailsContainer.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submissionErrors: PropTypes.arrayOf(PropTypes.string),
  isValid: PropTypes.bool.isRequired,
  handleGoBack: PropTypes.func.isRequired,
  showBackBtn: PropTypes.bool,
  handleCancel: PropTypes.func,
  showCancelButton: PropTypes.bool,
  title: PropTypes.string,
  previousStep: PropTypes.number,
};

ServiceDetailsContainer.defaultProps = {
  showBackBtn: true,
  showCancelButton: false,
  title: I18n.t('registration.service_details.title'),
  previousStep: 2,
};

export default ServiceDetailsContainer;
